import React from 'react';
import { connect } from 'react-redux';
import noPhoto from '../../../assets/img/imperial_tobacco.png';
import {Cancel, Giftbox, Alert, Game} from '../icons';

import './style.css';

const ProductImage = ({
  image = noPhoto,
  div = false,
  labels = { inBasket: false, featured: false, reward: false, new: false },
  isBluBar
}, props) => {
  const renderStateLabels = () => {
    let renderedLabels = [];

    // Discontinued over-rides out of stock, as from a logical standpoint, if something is discontinued, it will be out of stock.
    if  (labels.stockStatus === 'Discontinued') {
      renderedLabels.push(
        <div key="reward-label" className="card-label legend-item red">
            <div className="svg-icon-container red-dark"><Cancel /></div>
            <p>DISCONTINUED</p>
        </div>
      );
    } else if  (labels.stockStatus === 'Out of Stock') {
      renderedLabels.push(
        <div key="reward-label" className="card-label legend-item red">
            <div className="svg-icon-container red"><Alert /></div>
            <p>OUT OF STOCK</p>
        </div>
      );
    }

    if  (labels.reward && props.hasRewardOutlet) {
      renderedLabels.push(
        <div key="reward-label" className="card-label legend-item yellow">
            <div className="svg-icon-container yellow"><Giftbox /></div>
        </div>
      );
    }

    if  (labels.new) {
      renderedLabels.push(
        <div key="new-label" className="card-label legend-item">
            <span className="no-icon green">new</span>
        </div>
      );
    }

    if  (labels.missingFromAudit) {
      renderedLabels.push(
        <div key="missing-label" className="card-label legend-item yellow">
          <div className="svg-icon-container yellow"><Alert /></div>
          <p>Missing from audit</p>
        </div>
      );
    }

    if  (labels.game) {
      renderedLabels.push(
        <div key="game-label" className="card-label legend-item red">
          <div className="svg-icon-container red game"><Game /></div>
          <p>Game</p>
        </div>
      );
    }
    return renderedLabels;
  };

  return(
    <div className="product-image-container">
      {isBluBar ?
      <img className="product-image-blu-bar" src={image} alt="Product"/> :
      <div>
        <div className="product-image-wrapper">
          {div ? <div className="product-image-div" style={{backgroundImage: `url(${image})`}}/> : <img className="product-image" src={image} alt="Product"/>}
        </div>
        <div className="corner-label-container">
          { renderStateLabels() }
        </div>
      </div>}
    </div>
  )
};

const mapStateToProps = ({
  viewConfig,
}) => ({
  hasRewardOutlet: viewConfig.profile.attributes['has-reward-outlet']
});

export default connect(mapStateToProps)(ProductImage);



// WEBPACK FOOTER //
// ./src/components/common/product/product-image.jsx